import React from 'react';

import Microdeb from '~Components/Microdeb';
import { RefundProps } from '../types';

export const RefundMicrodeb = (props: RefundProps) => {
  const { amount, onCompleted, onFail, transactionId } = props;

  /* If props are invalid terminate */
  if (!transactionId || !amount) return null;

  // TODO: Don't hardcode VAT?

  return (
    <Microdeb
      id={transactionId}
      amount={amount}
      vat={12}
      onFail={() => onFail()}
      isFailing={false}
      type="REFUND"
      onComplete={() => onCompleted()}
    />
  );
};
